var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 32,
    height: 32,
    fill: "url(#pattern0_458_3531)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_458_3531",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_458_3531",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_458_3531",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAESklEQVR4nO3dyY+NWRjH8bcanTYkmrYxRdCGRKrTSxbEHCsVItg0FkKEiNiIdEvZYmFhKFEWpEgMWyHGnbGb7rYyRQxBIViYS1W+cnJPxVXK9d53OM976jyfP+De97m/93mnc+55o0gppZRSSimllFLKC8CPwExgJ3ABeAB8AJ4A14AjwBJggPS2hhDEauAp8XwEGoFB0tve5QC/A7dI5g2wQrqGLgOYC7wmPXOI6y5dj9eAGfbQk5Ud0jV5CxgDvCR7evhKAjhNPt4CQxJtVKiAWeRrt3SNXiG/7mhnzku/SNfpBeBnoIX8LZau1QvAQtw4Il2rF4ANjgL5V7pWL1C6gXPhiXStXgCaHAXyXrpWLwCbHAVyV7pWLwCrHAVyTrrWQgNqgNnA/44C2SZdc2EB04HLuDVNuu6idsQV3HsM9JD+DULviHL6xBfZjih3PfjuQL4j2r0CaqMQka4jWoEDwGTgdoZPeOui0JBNEGPLPm8w8E/KMJ4Hd1VFxkF0+OyfgM0JH8sfB0ZGoSDHIDr5rl/NDR3w6DufaybOnShsV9g9bCwwCZgHTAVGAD/4EERHZrttLeuABuCQDeovW1/fqGiA3sAy4Jh5svmNH+YZsN9eBdUUPQgvmclgwPIYbd3RJWBChc+t0SCqD6N/ygkCZg+uL+8WNIjEnTEMuEk29gLdtCMSAvrk8Ni62kNemOeIzgCHkdWqQXwOw1z+SWmzO0PYHVHOXh251qod0XkYtY6DaNOOKMaksjYNIt7h6qyjQNYkPaQGJcX/7qpVL12rF+wImAt7pGv1gsNAGqVr9QJww1EgG6Vr9QJwxlEga6Vr9QLwp6NA2vSyN14g4xwF0k6DiRGKWYAFgWAO6DOszgOZKBBIO+2Yb4RyEFmt2jFfD1D9l8MM8WppMB2GcLO6L9lnh3DrgKsJgzGzWcIeJwH6ASdzmORQp8EkD8Xs2UuBh1WGcREYX+FzazSYFIBeNpijwLsKE+WaEkyUq9OOST+VdLQdfzcrtE0BhscNoWjBAD3tQpjrgV32KcJ2O2A33xy6o1DhMBi7UzXGeMrdYs+lM6NQkU0wYyp0xNaEy/2dAkZFoSLjYIChZqEY0nlh1m+MQkY2wZhz3R2yYbprjvTvUgiUruL+Rp459/wm/Xt0hY7JknmaoYsGFKxjVn6xQSqS7phm7ZLidUzYV11VdIx55YQL27+7USoywaxxFMgF/b1jALY4CuRenO0JHroIZrEAOxx1SLN0rV6gtBqDC1ela/UCsMBRIIela/UC0NcuHpO3P6Rr9QalMYw8mQEsfV1FXHZ4Nk8NsTdGlaSczlSJeePbQPs1Ki4z7GpH+rK2LPZGqNxfm6fPr9Iyw64Z/ZfS3HDqiyWzYIZdU8xbNucMPUxlzQwomZE++1boOD7aSXR6AncQzHQ7U/E8cN/eSDbbv2SYBTEX6X2GUkoppZRSSikVdVGfALp/WNucVIX0AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.6385596802ae817281cd7b984c70742f.svg";
export { ForwardRef as ReactComponent };